module.exports = __webpack_public_path__ + "img/PL08046.2a61ae54.png";